import React, { useEffect, useState } from "react";
import { AspectRatio, Box } from "@chakra-ui/react";
import Balancer from "react-wrap-balancer";
import { isSafari } from "react-device-detect";
import { BookDemoButton } from "components/event-tracking";
import { HeroSpotlightBackgroundEffects } from "components/hero";
import { Section } from "components/section";
import { FillImage } from "components/images";
import { FadeIn } from "ui/animations";
import { TextTitle } from "ui/text";
import staticImage from "../../../../../public/assets/platform/real-time-personalization/hero.png";
import { HeroAnimation } from "./hero-animation";

type Props = {
  eyebrow?: string;
  title: string;
  description: string;
};

export function RealTimeHero({ eyebrow, title, description }: Props) {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  const renderHeroMedia = () => {
    if (!isClient) {
      return <Box boxSize="100%" bg="new.gray.50" />;
    }

    if (isSafari) {
      return <FillImage src={staticImage} alt="Real-time personalization data flow" />;
    }

    return <HeroAnimation />;
  };

  return (
    <Box as="section" pos="relative" overflow="hidden" bg="new.green.150">
      <HeroSpotlightBackgroundEffects theme="light" bgColor="new.green.150" spotlightColor="white" />

      <Box pos="relative">
        <FadeIn duration={0.3}>
          <Section as="div" themeBgColor="new.green.150" my="0" pt="biggest">
            <TextTitle
              size="xl"
              align="center"
              chip={eyebrow ? { text: eyebrow } : undefined}
              titleAs="h1"
              title={<Balancer>{title}</Balancer>}
              description={description}
              descriptionAs="h2"
              maxW="900px"
              descriptionMaxW="800px"
              actions={<BookDemoButton />}
            />
          </Section>

          <Section as="div" themeBgColor="white" my="0" py="biggest">
            <AspectRatio
              ratio={1204 / 522}
              pos="relative"
              w="100%"
              border="1px"
              borderColor="brand.border.extraLight"
              borderRadius={{ base: "small", md: "bigger" }}
              overflow="hidden"
            >
              <Box boxSize="100%" pos="relative">
                {renderHeroMedia()}
              </Box>
            </AspectRatio>
          </Section>
        </FadeIn>
      </Box>
    </Box>
  );
}
